import React from 'react';
import PropTypes from 'prop-types';
import { ButtonPrimary } from '@spotify-internal/creator-tape';
import * as Sentry from '@sentry/browser';
import { ErrorPage } from '../shared/components/ErrorPage';

export class AppError extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  };

  static getDerivedStateFromError(error) {
    return { error };
  }

  state = {
    error: undefined,
  };

  componentDidCatch(error) {
    Sentry.withScope(scope => {
      scope.setLevel(Sentry.Severity.Fatal);
      Sentry.captureException(error);
    });
  }

  render() {
    if (this.state.error) {
      return (
        <ErrorPage
          action={
            <ButtonPrimary onClick={() => window.location.reload()}>
              Reload
            </ButtonPrimary>
          }
        />
      );
    }

    return this.props.children;
  }
}
